import HTTPResponseEntity        from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';

export { IMAPOptionsHTTPMappings as default };

/**
* Imap Options HTTP Service
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class IMAPOptionsHTTPMappings {
  /**
   * Makes an HTTP Request to disable imap in the backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {IMAPOptionsItem}    options
   * @param {HTTPResponseEntity} response
   *
   * @return {void}
   */
  async map(options, response) {
    if (!response.results) {
      return;
    }

    options.enabled = response.results.enabled || false;
    options.allowed = response.results.allowed || false;
  }
}